export const space = {
  '0': '0rem',
  '4XS': '0.125rem',
  '3XS': '0.25rem',
  '2XS': '0.375rem',
  XS: '0.5rem',
  S: '0.625rem',
  M: '0.75rem',
  XL: '1rem',
  '3XL': '1.25rem',
  '4XL': '1.5rem',
  '5XL': '1.75rem',
  '6XL': '2rem',
  '7XL': '2.5rem',
  '8XL': '2.75rem',
  '9XL': '3rem',
  '10XL': '3.5rem',
  '11XL': '4rem',
  '12XL': '4.5rem',
  L: '0.875rem',
  '2XL': '1.125rem',
}
export type SpaceTokens = {
  [K in keyof typeof space]: string
}
export type SpaceKeys = keyof typeof space
